import { render, staticRenderFns } from "./c-dropdown.vue?vue&type=template&id=0c0ebc1a&scoped=true&"
import script from "./c-dropdown.vue?vue&type=script&lang=js&"
export * from "./c-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./c-dropdown.vue?vue&type=style&index=0&id=0c0ebc1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0ebc1a",
  null
  
)

export default component.exports